import { useMemo } from 'react';
import { useShell } from '../shell/ShellContext';
import { staticHomeData } from './data/staticHome';
import type { HomeData } from './data/types';

/**
 * Point unique d'où l'Accueil tire ses données « résumé ». Aujourd'hui tout est statique : le jour où un service
 * (Vault, Trésorerie, activité du serveur) fournit de vraies données, sa part se remplace ici et nulle part ailleurs.
 * La carte Notes ne passe pas par ce hook : elle vient du module (`modules/notes/home`).
 */
export function useHomeData(): HomeData {
  const { user } = useShell();
  return useMemo(() => staticHomeData(new Date(), user.initial), [user.initial]);
}
